import { useEffect, useState } from "react";
import { api } from "../api";

/**
 * Dropdown de filtro por plataforma - sincronizado com localStorage (chave
 * `sh_search_platform`, partilhada com a topbar) e com um param opcional na
 * URL (`plataforma`) para permitir deep-linking.
 *
 * Props:
 *   value      valor actual (controlled) - normalmente vindo da URL
 *   onChange   callback com o novo valor (string)
 *   testid     data-testid do <select>
 *   className  classe extra
 */
export default function PlatformFilter({ value, onChange, testid = "platform-filter", className = "" }) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    api.get("/platforms/lookup").then(({ data }) => {
      setOptions((data || []).map((p) => ({ value: p.nome, label: p.nome })));
    }).catch(() => setOptions([]));
  }, []);

  const handleChange = (v) => {
    try { localStorage.setItem("sh_search_platform", v || ""); } catch {}
    onChange(v);
  };

  return (
    <select
      value={value || ""}
      onChange={(e) => handleChange(e.target.value)}
      data-testid={testid}
      className={`text-sm bg-white border border-slate-300 rounded-md px-2 py-1 focus:ring-2 focus:ring-blue/20 focus:outline-none ${className}`}
    >
      <option value="">Todas as plataformas</option>
      {options.map((p) => (
        <option key={p.value} value={p.value}>{p.label}</option>
      ))}
    </select>
  );
}
